



























































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalSuratRujukanBalikHaji from "@/components/modal/CardModalSuratRujukanBalikHaji.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import SuratRujukanBalikHaji from "@/services/SuratRujukanBalikHaji";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: { CardModalSuratRujukanBalikHaji, CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSuratRujukanBalikHaji extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  data: any = null;
  editing: any = null;
  modalOpen = false;
  modalTtd = false;
  loading = false;
  deleting = false;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  get stateuser() {
    return userModule.user;
  }
  get pasien() {
    return storePasien.pasien || {};
  }
  get canMake() {
    if (this.readOnly) return false;
    return ["dokter", "perawat", "bidan"].includes(
      this.stateuser?.profesi?.toLowerCase()
    );
  }
  get canEdit() {
    return !this.readOnly && this.data && this.canMake && !this.data.signed;
  }
  get canSign() {
    return (
      !this.readOnly &&
      this.data &&
      this.stateuser?.id == this.data?.dokter?.id &&
      !this.data?.signed_at
    );
  }

  formatDate(d) {
    return getHumanDateTime(d);
  }

  mounted() {
    this.fetch();
  }

  async fetch() {
    this.loading = true;
    try {
      const resp = await SuratRujukanBalikHaji.getByRegister(this.register);
      this.data = resp?.data?.status == "1" ? resp.data.data : null;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.editing = null;
    this.modalOpen = true;
  }

  openEdit() {
    this.editing = this.data;
    this.modalOpen = true;
  }

  onSaved() {
    this.fetch();
  }

  cetak() {
    SuratRujukanBalikHaji.print(this.data.id);
  }

  async passTtd(password) {
    try {
      const resp = await SuratRujukanBalikHaji.sign(this.data.id, { password });
      if (resp?.data?.status == 1) {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil tanda tangan Surat Rujukan Balik Haji");
        appModule.addMsgTtd("");
        this.fetch();
      } else {
        appModule.addMsgTtd(resp?.data?.message);
      }
    } catch (e) {
      // ErrorAlert already shown in service
    }
  }

  async remove() {
    if (!confirm("Anda yakin akan menghapus Surat Rujukan Balik Haji ini?")) return;
    this.deleting = true;
    try {
      const resp = await SuratRujukanBalikHaji.destroy(this.data.id);
      if (resp?.data?.status == 1) {
        appModule.NoticeDelay(resp.data.message);
        this.data = null;
      }
    } finally {
      this.deleting = false;
    }
  }
}
